
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Luxurybusrentalinpune() {



    const cardData =
    {
        keyword: 'Luxury Bus Rental in Pune',
        heading: 'Amruta Travels: Luxury Bus Rental in Pune',
        headingDescription: 'Amruta Travels offers Luxury Bus Rental in Pune, providing an unparalleled travel experience for various occasions. Whether you are planning a corporate event, wedding, school trip, or a family outing, our fleet of luxurious buses ensures a comfortable and hassle-free journey. With experienced drivers, punctual service, competitive pricing, and 24/7 support, we make group travel simple and stress-free. Choose from our range of luxury buses, including 32-seater, 35-seater, 45-seater, and 50-seater options, to suit your group size. Book your Luxury Bus with Amruta Travels and travel together in comfort and style!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],
  "services": [
    {
      "name": "Luxury Bus Rental in Pimpri Chinchwad",
      "description": "Amruta Travels offers premium luxury bus rentals in Pimpri Chinchwad for weddings, corporate events, and group tours. Enjoy plush seating, air-conditioning, entertainment systems, and professional drivers for a smooth and stylish travel experience across PCMC and beyond."
    },
    {
      "name": "Luxury Bus Rental in Kharadi",
      "description": "Experience comfort and elegance with Amruta Travels' luxury buses on rent in Kharadi. Whether it's a business event, outstation trip, or wedding shuttle, our high-end buses offer spacious interiors and modern amenities to elevate your group travel."
    },
    {
      "name": "Luxury Bus on Rent in Yerawada, Pune",
      "description": "Looking for luxury transport from Yerawada? Amruta Travels provides top-tier buses for rental with amenities like reclining seats, air conditioning, and music systems. Ideal for VIP travel, family functions, and corporate events in Pune and outstation."
    },
    {
      "name": "Luxury Bus on Rent in Vishrantwadi, Pune",
      "description": "Amruta Travels offers luxury bus rentals in Vishrantwadi for personal, religious, and professional events. Our premium fleet ensures a superior travel experience with comfortable seating, AC, and courteous drivers ready for local or long-distance trips."
    },
    {
      "name": "14, 17, 20, 25 Seater Luxury Bus on Rent Pune",
      "description": "Choose from Amruta Travels’ range of small-sized luxury buses (14 to 25 seaters) for premium group travel in Pune. These mini luxury buses are perfect for intimate weddings, VIP airport transfers, and corporate outings needing a touch of class."
    },
    {
      "name": "32, 35, 40, 45 Seater Luxury Bus Hire in Pimpri Chinchwad",
      "description": "For larger groups, Amruta Travels offers 32 to 45-seater luxury bus hire services in Pimpri Chinchwad. Ideal for destination weddings, company tours, or religious pilgrimages, our luxury buses provide elegant interiors, AC, entertainment, and reliable service."
    },
    {
      "name": "Luxury Bus on Rent in Hadapsar Pune",
      "description": "Get access to premium travel solutions in Hadapsar with Amruta Travels' luxury bus rental service. Suitable for events, outstation trips, or corporate transfers, these high-comfort buses offer stylish interiors and smooth travel at competitive rates."
    },
    {
      "name": "Luxury Bus on Rent for Picnic in Pune",
      "description": "Upgrade your picnic experience with a luxury bus rental from Amruta Travels in Pune. Our buses come with ample legroom, AC, and music systems, making them ideal for school trips, college outings, and office picnics seeking comfort and convenience."
    },
    {
      "name": "Mini Luxury Bus Hire in Pune",
      "description": "Amruta Travels provides mini luxury buses for hire in Pune for smaller groups looking for comfort and style. Whether it's a VIP guest tour, private event, or premium shuttle, our fleet is ready with AC, soft seats, and professional chauffeurs."
    }
  ],
  "tableData": [
    ["Luxury Bus Rental in Pimpri Chinchwad", "Luxury Bus Rental in Kharadi"],
    ["Luxury Bus on Rent in Yerawada, Pune", "Luxury Bus on Rent in Vishrantwadi, Pune"],
    ["14, 17, 20, 25 Seater Luxury Bus on Rent Pune", "32, 35, 40, 45 Seater Luxury Bus Hire in Pimpri Chinchwad"],
    ["Luxury Bus on Rent in Hadapsar Pune", "Luxury Bus on Rent for Picnic in Pune"],
    ["Mini Luxury Bus Hire in Pune", ""]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Premium Travel Experience",
    "WhyChoosedescription": "Amruta Travels offers Luxury Bus Rental in Pune for those who seek comfort, class, and elegance. Our luxury buses are equipped with plush seating, AC, entertainment systems, and modern interiors."
  },
  {
    "WhyChooseheading": "Ideal for High-End Events and Corporate Travel",
    "WhyChoosedescription": "Perfect for VIP guest transport, corporate events, weddings, film shoots, and executive tours—our luxury buses add sophistication and style to your travel experience."
  },
  {
    "WhyChooseheading": "Spacious and Feature-Rich Interiors",
    "WhyChoosedescription": "Our luxury buses offer reclining seats, large windows, ambient lighting, ample legroom, and onboard entertainment to make your journey enjoyable and relaxing."
  },
  {
    "WhyChooseheading": "Trained and Uniformed Chauffeurs",
    "WhyChoosedescription": "Our professional, courteous chauffeurs are trained in premium service etiquette and ensure a smooth, timely, and respectful travel experience from start to finish."
  },
  {
    "WhyChooseheading": "Transparent Pricing with Premium Value",
    "WhyChoosedescription": "We provide clear and fair pricing for our Luxury Bus Rental in Pune. Get the best value for high-end travel with no hidden charges or last-minute surprises."
  },
  {
    "WhyChooseheading": "Immaculately Maintained Fleet",
    "WhyChoosedescription": "Each luxury bus is meticulously cleaned and regularly maintained, ensuring top-tier presentation and performance every time you travel with us."
  },
  {
    "WhyChooseheading": "Custom Routes and Flexible Scheduling",
    "WhyChoosedescription": "From one-day bookings to multi-day travel plans, we tailor the journey to fit your needs. Choose your own pick-up points, stops, and departure times for maximum convenience."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking and Priority Support",
    "WhyChoosedescription": "Booking a Luxury Bus with Amruta Travels is fast and easy. Our dedicated support team ensures priority service, trip planning assistance, and seamless coordination throughout your rental."
  }
]































    }

const faqData = [
  {
    question: 'How can I rent a luxury bus in Pune with Amruta Travels?',
    answer: 'You can rent a luxury bus in Pune by booking through our website, calling our support team, or visiting our office. We’ll help you select the perfect luxury bus based on your group size and travel needs.',
  },
  {
    question: 'What features do your luxury buses offer?',
    answer: 'Our luxury buses come with premium push-back seats, air conditioning, LED screens, music systems, mood lighting, ample legroom, and large luggage space. These buses are designed to offer top-tier comfort and style.',
  },
  {
    question: 'For what occasions can I hire a luxury bus?',
    answer: 'Luxury buses are ideal for weddings, corporate travel, VIP transfers, outstation tours, and special events where premium transportation is needed. They offer both comfort and class.',
  },
  {
    question: 'Are luxury buses available for outstation travel from Pune?',
    answer: 'Yes, our luxury buses are perfect for outstation trips. Whether it’s a business trip or a destination wedding, we ensure a first-class travel experience with well-trained drivers and smooth service.',
  },
  {
    question: 'Are your luxury buses well-maintained and sanitized?',
    answer: 'Absolutely. All our luxury buses undergo regular maintenance and are thoroughly cleaned and sanitized before every journey to ensure a hygienic and pleasant experience.',
  },
  {
    question: 'Do luxury buses come with professional drivers?',
    answer: 'Yes, every luxury bus rental includes a uniformed, professional, and experienced driver who ensures safety, punctuality, and courteous service.',
  },
  {
    question: 'Can I customize the route and pickup points for the luxury bus?',
    answer: 'Yes, we offer fully flexible routes and multiple pickup and drop-off locations. Share your itinerary with us, and we’ll tailor the journey to suit your plans.',
  },
  {
    question: 'How much does it cost to rent a luxury bus in Pune?',
    answer: 'The cost depends on the bus size, duration of the trip, distance, and any custom amenities required. Contact us for a personalized quote based on your travel details.',
  },
  {
    question: 'Why choose Amruta Travels for luxury bus rental in Pune?',
    answer: 'Amruta Travels offers premium luxury buses with exceptional service standards, experienced drivers, and customized travel solutions. We prioritize your comfort, elegance, and satisfaction on every ride.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rohit Nair',
    role: 'Corporate Event Planner, Pune',
    text: 'We rented a luxury bus from Amruta Travels for an executive offsite. The bus was immaculate, equipped with all the amenities, and the staff was highly professional. Truly luxurious and worth every penny.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sneha Mahajan',
    role: 'Bride, Pune',
    text: 'Amruta Travels provided a luxury bus for our wedding guests. It was spacious, comfortable, and beautifully maintained. Our guests were impressed, and the experience was top-notch!',
    rating: 5,
  },
];









































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Bus Rental in Pune",
  "image": "https://bushireinpune.com/assets/images/luxury-bus-rental-pune.jpg",
  "description": "Experience luxury travel with Amruta Travels. Rent luxury buses for picnics, corporate events, and outstation trips in Pune, with options ranging from 14 to 45 seats.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5000"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "60", // Adjust based on per km or flat rate for luxury bus rental
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/luxury-bus-rental-in-pune"
  }
};








    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Luxury Bus Rental in Pune | 14 to 45 Seater Luxury Bus Hire | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book a luxury bus rental in Pune for picnics, corporate events, or outstation trips. Choose from a variety of seating capacities, including 14, 17, 20, 25, 32, 35, 40, and 45-seaters." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/20.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Luxurybusrentalinpune;